export const computedMapDict = function () {
    return {
        _dictCustomType: () => [...customType],
        _dictBankType: () => [...bankType],
        _dictCompanyNature: () => [...companyNature],
        _dictTrueOrFalse: () => [...trueOrFalse],
        _dictOneOrZero: () => [...oneOrZero],
        _dictAllOrNone: () => [...allOrNone],
        _dictContractType: () => [...contractType],
        _dictContractAttribute: () => [...contractAttribute],
        _dictContractStatus: () => [...contractStatus],
        _dictJhContractStatus: () => [...jhContractStatus],
        _dictUseOrUnused: () => [...useOrUnused],
        _dictBusinessModel: () => [...businessModel],
        _dictCostStandardType: () => [...costStandardType],
        _dictStandSettlementType: () => [...standSettlementType],
        _dictProjectType: () => [...projectType],
        _dictProjectStatus: () => [...projectStatus],
        _dictEnableType: () => [...enableType],
        _dictParamType: () => [...paramType],
        _dictPortAndStationType: () => [...portAndStationType],
        _dictEntrustType: () => [...entrustType],
        _dictValidType: () => [...validType],
        _dictTransportModeType: () => [...transportModeType],
        _dictPlanType: () => [...planType],
        _dictEntrustStatus: () => [...entrustStatus],
        _dictIfHeavyType: () => [...ifHeavyType],
        _dictTradeType: () => [...tradeType],
        _dictOrgStatusType: () => [...orgStatusType],
        _dictAccountType: () => [...accountType],
        _dictAccountStatus: () => [...accountStatus],
        _dictSexType: () => [...sexType],
        _dictDicType: () => [...dicType],
        _dictPlanStatus: () => [...planStatus],
        _dictPackingWay: () => [...packingWay],
        _dictSpecify: () => [...specify],
        _dictJobStatus: () => [...jobStatus],
        _dictContainerJobType: () => [...containerJobType],
        _dictExcelFieldTypes: () => [...excelFieldTypes],
        _dictPriorityType: () => [...priorityType],
        _dictPriorityTypes: () => [...priorityTypes],
        _dictOperatorType: () => [...operatorType],
        _dictOperatorTwoType: () => [...operatorTwoType],
        _dictAttrType: () => [...attrType],
        _dictSOrB: () => [...sOrB],
        _dictJobStatusFilter: () => [...jobStatusFilter],
        _dictStackOrder: () => [...stackOrder],
        _dictImportAndExportType: () => [...importAndExportType],
        _dictImportAndExportTypeByIO: () => [...importAndExportTypeByIO],
        _dictImportExport: () => [...importExport],
        _dictEntrustNoType: () => [...entrustNoType],
        _dictContainerStatus: () => [...containerStatus],
        _dictCommandStatus: () => [...commandStatus],
        _dictJobPurpose: () => [...jobPurpose],
        _dictRegisterType: () => [...registerType],
        _dictJobAction: () => [...jobAction],
        _dictYardPlanType: () => [...yardPlanType],
        _dictShipType: () => [...shipType],
        _dictShipPlanStatus: () => [...shipPlanStatus],
        _dictIsFinish: () => [...isFinish],
        _dictTsJobStatus: () => [...tsJobStatus],
        _dictTallyPlanStatus: () => [...tallyPlanStatus],
        _dictPortCode: () => [...portCode],
        _dictShipPlanType: () => [...shipPlanType],
        _dictEnchaseWayType: () => [...enchaseWayType],
        _dictIsChange: () => [...isChange],
        _dictReleaseType: () => [...releaseType],
        _dictSettlementType: () => [...settlementType],
        _dictBusinessModule: () => [...businessModule],
        _dictRuleOperator: () => [...ruleOperator],
        _dictRuleOperatorType: () => [...ruleOperatorType],
        _dictRuleConnect: () => [...ruleConnect],
        _dictFeeUnit: () => [...feeUnit],
        _dictDamaged: () => [...damaged],
        _dictPlanReport: () => [...planReport],
        _dictTaskType: () => [...taskType],
        _dictAccountChangeWay: () => [...accountChangeWay],
        _dictAllJobStatus: () => [...allJobStatus],
        _dictAllJobStatusNew: () => [...allJobStatusNew],
        _dictOperationState: () => [...operationState],
        _dictWarehouse: () => [...warehouse],
        _dictAreaType: () => [...areaType],
        _dictPrinciple: () => [...principle],
        _dictPriority: () => [...priority],
        _dictManagement: () => [...management],
        _dictPutStyle: () => [...putStyle],
        _dictLimitFactor: () => [...limitFactor],
        _dictCalendarType: () => [...calendarType],
        _dictBusinessMode: () => [...businessMode],
        _dictRuleCondition: () => [...ruleCondition],
        _dictRuleCondition2: () => [...ruleCondition2],
        _dictCardType: () => [...cardType],
        _dictUseStatus: () => [...useStatus],
        _dictProductName: () => [...productName],
        _dictFormat1: () => [...format1],
        _dictFormat2: () => [...format2],
        _dictFormat3: () => [...format3],
        _dictQuality: () => [...quality],
        _dictMeterStyle: () => [...meterStyle],
        _dictAccountTypes: () => [...accountTypes],
        _dictManufactor: () => [...manufactor],
        _dictAccountType: () => [...accountType],
        _dictAccountNature: () => [...accountNature],
        _dictRoomType: () => [...roomType],
        _dictWorkMode: () => [...workMode],
        _dictOverdueType: () => [...overdueType],
        _dictInSettleStyle: () => [...inSettleStyle],
        _dictOutSettleStyle: () => [...outSettleStyle],
        _dictControlWay: () => [...controlWay],
        _dictControlType: () => [...controlType],
        _dictControlStatus: () => [...controlStatus],
        _dictAuditStatus: () => [...auditStatus],
        _dictAccountPageType: () => [...accountPageType],
        _dictAdjustWay: () => [...adjustWay],
        _dictAdjustStatus: () => [...adjustStatus],
        _dictIsDamagedType: () => [...isDamagedType],
        _dictPreStatus: () => [...preStatus],
        _dictPreStatus2: () => [...preStatus2],
        _dictStockStatus: () => [...stockStatus],
        _dictHandleStatus: () => [...handleStatus],
        _dictRelocationType: () => [...relocationType],
        _dictCountNumUnitEnum: () => [...countNumUnitEnum],
        _dictShiftStatus: () => [...shiftStatus],
        _dictCheckStatus: () => [...checkStatus],
        _dictPresource: () => [...presource],
        _dictAddPresource: () => [...addPresource],
        _dictOutWay: () => [...outWay],
        _dictLimitRange: () => [...limitRange],
        _dictStockType: () => [...stockType],
        _dictBillStatus: () => [...billStatus],
        _dictBillAuditStatus: () => [...billAuditStatus],
        _dictOutBillStatus: () => [...OutBillStatus],
        _dictBusinessType: () => [...businessType],
        _dictBookStatus: () => [...bookStatus],
        _dictInwayStatus: () => [...inwayStatus],
        _dictGateStatus: () => [...gateStatus],
        _dictCargoFromStatus: () => [...cargoFromStatus],
        _dictMachiningModeStatus: () => [...machiningModeStatus],
        _dictInOutType: () => [...inOutType],
        _dictPackageMode: () => [...packageMode],
        _dictAllOrPart: () => [...allOrPart],
        _dictInOutWay: () => [...inOutWay],
        _dictOrderStatus: () => [...orderStatus],
        _dictPiecesType: () => [...piecesType],
        _dictNewPiecesType: () => [...newPiecesType],
        _dictPayWay: () => [...payWay],
        _dictChargeType: () => [...chargeType],
        _dictInSettlementMode: () => [...inSettlementMode],
		_dictDuiOutWay: () => [...duiOutWay],
        _dictHasOutWay: () => [...hasOutWay],
        _dictOriOutWay: () => [...oriOutWay],
        _dictNewAccountNature: () => [...newAccountNature],
        _dictPrePaymentStatus: () => [...prePaymentStatus],
        _dictSettleWay: () => [...settleWay],
        _dictNewSettleWay: () => [...newSettleWay],
        _dictWriteOfWay: () => [...writeOfWay],
        _dictRecordType: () => [...recordType],
        _dictAuthorizeType: () => [...authorizeType],
        _dictPowerType: () => [...powerType],
        _dictSendOutWay: () => [...sendOutWay],
        _dictProofreadBill: () => [...proofreadBill],
        _dictLuShip: () => [...luShip],
        _dictLuTrain: () => [...luTrain],
        _dictCargoType4DailyReport: () => [...cargoType4DailyReport],
    }
}
export const filtersMapDict = function () {
    return {
        _filterCustomType: (key) => customType.get(key),
        _filterBankType: (key) => bankType.get(key),
        _filterCompanyNature: (key) => companyNature.get(key),
        _filterTrueOrFalse: (key) => trueOrFalse.get(key),
        _filterAllOrNone: (key) => allOrNone.get(key),
        _filterOneOrZero: (key) => oneOrZero.get(key),
        _filterContractType: (key) => contractType.get(key),
        _filterContractAttribute: (key) => contractAttribute.get(key),
        _filterContractStatus: (key) => contractStatus.get(key),
        _filterJhContractStatus: (key) => jhContractStatus.get(key),
        _filterUseOrUnused: (key) => useOrUnused.get(key),
        _filterBusinessModel: (key) => businessModel.get(key),
        _filterCostStandardType: (key) => costStandardType.get(key),
        _filterStandSettlementType: (key) => standSettlementType.get(key),
        _filterProjectType: (key) => projectType.get(key),
        _filterProjectStatus: (key) => projectStatus.get(key),
        _filterEnableType: (key) => enableType.get(key),
        _filterParamType: (key) => paramType.get(key),
        _filterPortAndStationType: (key) => portAndStationType.get(key),
        _filterEntrustType: (key) => entrustType.get(key),
        _filterValidType: (key) => validType.get(key),
        _filterTransportModeType: (key) => transportModeType.get(key),
        _filterPlanType: (key) => planType.get(key),
        _filterEntrustStatus: (key) => entrustStatus.get(key),
        _filterIfHeavyType: (key) => ifHeavyType.get(key),
        _filterTradeType: (key) => tradeType.get(key),
        _filterOrgStatusType: (key) => orgStatusType.get(key),
        _filterAccountType: (key) => accountType.get(key),
        _filterAccountTypes: (key) => accountTypes.get(key),
        _filterAccountStatus: (key) => accountStatus.get(key),
        _filterSexType: (key) => sexType.get(key),
        _filterDicType: (key) => dicType.get(key),
        _filterPlanStatus: (key) => planStatus.get(key),
        _filterExcelFieldTypes: (key) => excelFieldTypes.get(key),
        _filterPackingWay: (key) => packingWay.get(key),
        _filterSpecify: (key) => specify.get(key),
        _filterJobStatus: (key) => jobStatus.get(key),
        _filterJobStatusFilter: (key) => jobStatusFilter.get(key),
        _filterContainerJobType: (key) => containerJobType.get(key),
        _filterOperatorType: (key) => operatorType.get(key),
        _filterOperatorTwoType: (key) => operatorTwoType.get(key),
        _filterAttrType: (key) => attrType.get(key),
        _filterSOrB: (key) => sOrB.get(key),
        _filterStackOrder: (key) => stackOrder.get(key),
        _filterImportAndExportType: (key) => importAndExportType.get(key),
        _filterImportExport: (key) => importExport.get(key),
        _filterContainerStatus: (key) => containerStatus.get(key),
        _filterCommandStatus: (key) => commandStatus.get(key),
        _filterJobPurpose: (key) => jobPurpose.get(key),
        _filterRegisterType: (key) => registerType.get(key),
        _filterJobAction: (key) => jobAction.get(key),
        _filterYardPlanType: (key) => yardPlanType.get(key),
        _filterShipType: (key) => shipType.get(key),
        _filterShipPlanStatus: (key) => shipPlanStatus.get(key),
        _filterIsFinish: (key) => isFinish.get(key),
        _filterTsJobStatus: (key) => tsJobStatus.get(key),
        _filterTsJobStatusNew: (key) => tsJobStatusNew.get(key),
        _filterAllJobStatus: (key) => allJobStatus.get(key),
        _filterAllJobStatusNew: (key) => allJobStatusNew.get(key),
        _filterTallyPlanStatus: (key) => tallyPlanStatus.get(key),
        _filterPortCode: (key) => portCode.get(key),
        _filterShipPlanType: (key) => shipPlanType.get(key),
        _filterEnchaseWayType: (key) => enchaseWayType.get(key),
        _filterIsChange: (key) => isChange.get(key),
        _filterReleaseType: (key) => releaseType.get(key),
        _filterSettlementType: (key) => settlementType.get(key),
        _filterIsDamagedType: (key) => isDamagedType.get(key),
        _filterBusinessModule: (key) => businessModule.get(key),
        _filterRuleOperator: (key) => ruleOperator.get(key),
        _filterRuleOperatorType: (key) => ruleOperatorType.get(key),
        _filterRuleConnect: (key) => ruleConnect.get(key),
        _filterFeeUnit: (key) => feeUnit.get(key),
        _filterDamaged: (key) => damaged.get(key),
        _filterPlanReport: (key) => planReport.get(key),
        _filterTaskType: (key) => taskType.get(key),
        _filterAccountChangeWay: (key) => accountChangeWay.get(key),
        _filterOperationState: (key) => operationState.get(key),
        _filterWarehouse: (key) => warehouse.get(key),
        _filterAreaType: (key) => areaType.get(key),
        _filterPrinciple: (key) => principle.get(key),
        _filterPriority: (key) => priority.get(key),
        _filterManagement: (key) => management.get(key),
        _filterPutStyle: (key) => putStyle.get(key),
        _filterLimitFactor: (key) => limitFactor.get(key),
        _filterCalendarType: (key) => calendarType.get(key),
        _filterBusinessMode: (key) => businessMode.get(key),
        _filterRuleCondition: (key) => ruleCondition.get(key),
        _filterRuleCondition2: (key) => ruleCondition2.get(key),
        _filterCardType: (key) => cardType.get(key),
        _filterUseStatus: (key) => useStatus.get(key),
        _filterProductName: (key) => productName.get(key),
        _filterFormat1: (key) => format1.get(key),
        _filterFormat2: (key) => format2.get(key),
        _filterFormat3: (key) => format3.get(key),
        _filterQuality: (key) => quality.get(key),
        _filterMeterStyle: (key) => meterStyle.get(key),
        _filterManufactor: (key) => manufactor.get(key),
        _filterRoomType: (key) => roomType.get(key),
        _filterWorkMode: (key) => workMode.get(key),
        _filterOverdueType: (key) => overdueType.get(key),
        _filterInSettleStyle: (key) => inSettleStyle.get(key),
        _filterOutSettleStyle: (key) => outSettleStyle.get(key),
        _filterControlWay: (key) => controlWay.get(key),
        _filterControlType: (key) => controlType.get(key),
        _filterControlStatus: (key) => controlStatus.get(key),
        _filterAuditStatus: (key) => auditStatus.get(key),
        _filterAccountPageType: (key) => accountPageType.get(key),
        _filterAdjustWay: (key) => adjustWay.get(key),
        _filterAdjustStatus: (key) => adjustStatus.get(key),
        _filterPreStatus: (key) => preStatus.get(key),
        _filterInWay: (key) => inWay.get(key),
        _filterStockStatus: (key) => stockStatus.get(key),
        _filterHandleStatus: (key) => handleStatus.get(key),
        _filterRelocationType: (key) => relocationType.get(key),
        _filterCountNumUnitEnum: (key) => countNumUnitEnum.get(key),
        _filterShiftStatus: (key) => shiftStatus.get(key),
        _filterCheckStatus: (key) => checkStatus.get(key),
        _filterPresource: (key) => presource.get(key),
        _filterAddPresource: (key) => addPresource.get(key),
        _filterBusinessType: (key) => businessType.get(key),
        _filterBookStatus: (key) => bookStatus.get(key),
        _filterInwayStatus: (key) => inwayStatus.get(key),
        _filterLimitRange: (key) => limitRange.get(key),
        _filterStockType: (key) => stockType.get(key),
        _filterOutWay: (key) => outWay.get(key),
        _filterBillStatus: (key) => billStatus.get(key),
        _filterBillAuditStatus: (key) => billAuditStatus.get(key),
        _filterOutBillStatus: (key) => OutBillStatus.get(key),
        _filterGateStatus: (key) => gateStatus.get(key),
        _filterCargoFromStatus: (key) => cargoFromStatus.get(key),
        _filterMachiningModeStatus: (key) => machiningModeStatus.get(key),
        _filterInOutType: (key) => inOutType.get(key),
        _filterPackageMode: (key) => packageMode.get(key),
        _filterAllOrPart: (key) => allOrPart.get(key),
        _filterInOutWay: (key) => inOutWay.get(key),
        _filterOrderStatus: (key) => orderStatus.get(key),
        _filterPiecesType: (key) => piecesType.get(key),
        _filterNewPiecesType: (key) => newPiecesType.get(key),
        _filterPayWay: (key) => payWay.get(key),
        _filterAccountNature: (key) => accountNature.get(key),
        _filterChargeType: (key) => chargeType.get(key),
        _filterInSettlementMode: (key) => inSettlementMode.get(key),
        _filterPrePaymentStatus: (key) => prePaymentStatus.get(key),
        _filterSettleWay: (key) => settleWay.get(key),
        _filterNewSettleWay: (key) => newSettleWay.get(key),
        _filterWriteOfWay: (key) => writeOfWay.get(key),
        _filterRecordType: (key) => recordType.get(key),
        _filterDuiOutWay: (key) => duiOutWay.get(key),
        _filterHasOutWay: (key) => hasOutWay.get(key),
        _filterOriOutWay: (key) => oriOutWay.get(key),
        _filterAuthorizeType: (key) => authorizeType.get(key),
        _filterPowerType: (key) => powerType.get(key),
        _filterSendOutWay: (key) => sendOutWay.get(key),
        _filterProofreadBill: (key) => proofreadBill.get(key),
        _filterZYZT: (key) => ZYZT.get(key),
        _filterTLJHLY: (key) => TLJHLY.get(key),
        _filterZYLX: (key) => ZYLX.get(key),
        _filterJCK: (key) => JCK.get(key),
        _filterFCSHZT: (key) => FCSHZT.get(key),
    }
}


/** ==========基础========= */
// 客户类型
export const customType = new Map([
    ['NORMAL', '合同客户'],
    ['TEMP', '临时客户'],
])
// 银行账户类型
export const bankType = new Map([
    ['B', '基本账户'],
    ['G', '一般账户'],
])
// 企业性质
export const companyNature = new Map([
    ['GYQY', '国有企业'],
    ['COMPANY_SS', '上市企业'],
    ['COMPANY_MY', '民营企业'],
    ['COMPANY_HZ', '合资企业'],
    ['COMPANY_QT', '其他企业']
])
// 是或否
export const trueOrFalse = new Map([
    [true, '是'],
    [false, '否']
])
// 是或否全部加工
export const allOrPart = new Map([
    [true, '全部加工'],
    [false, '部分加工']
])
// 是或否
export const oneOrZero = new Map([
    ['1', '是'],
    ['0', '否']
])
// 有或无
export const allOrNone = new Map([
    [true, '有'],
    [false, '无']
])
// 合同类型
export const contractType = new Map([
    ['I', '收入合同'],
    ['O', '成本合同']
])
// 合同属性
export const contractAttribute = new Map([
    ['TSHT', '正式合同'],
    ['LSHT', '临时合同']
])
// 合同状态
export const contractStatus = new Map([
    // ['A','审批中'],
    ['C', '已生效'],
    ['D', '起草'],
    ['R', '退回'],
    ['S', '待签订'],
    ['V', '已作废'],
])
// 合同状态(件货)
export const jhContractStatus = new Map([
    ['A','审核中'],
    ['C', '已生效'],
    ['D', '起草'],
    ['R', '退回'],
    ['E', '已终止'],
])
// 合同使用状态
export const useOrUnused = new Map([
    [true, '已使用'],
    [false, '未使用']
])
// 业务模式
export const businessModel = new Map([
    // ['XHQHFK', '先货权后付款'],
    // ['DXCG', '定向采购'],
    // ['JBXS', '集并销售'],
    // ['HDFK', '货到付款'],
    // ['QCWL', '全程物流'],
    // ['DZZY', '吊装作业'],
    ['JZX', '集装箱业务'],
    ['JSH', '件散货业务']
])
// 结算标准??费用标准
export const costStandardType = new Map([
    ['BSTD', '基本标准'],
    ['CSTD', '合同标准'],
    // ['PSTD','项目标准'],
])
export const standSettlementType = new Map([
    ['B', '基本标准'],
    ['P', '项目标准'],
])
// 项目类型
export const projectType = new Map([
    ['NORMAL', '正式项目'],
    ['TEMP', '临时项目']
])
// 项目状态
export const projectStatus = new Map([
    ['D', '起草'],
    ['A', '审批中'],
    ['R', '退回'],
    ['Z', '已作废'],
    ['S', '已立项'],
    ['C', '执行中'],
    ['O', '已结束'],
    ['F', '已冻结'],
])

// 已启用或未启用
export const enableType = new Map([
    [true, '已启用'],
    [false, '未启用']
])

// 系统参数类型
export const paramType = new Map([
    ['B', '业务级'],
    ['S', '系统级'],
])

// 港口和站点
export const portAndStationType = new Map([
    ['P', '港口'],
    ['S', '站点'],
])

// 委托类型名称
export const entrustType = new Map([
    ['JCRK', '进场入库'],
    ['THCK', '提货出库'],
    ['CXWT', '拆箱委托'],
    ['BCWT', '补充进场入库'],
])

// 委托类型名称
export const packingWay = new Map([
    ['C', '集装箱'],
    ['B', '散货'],
    ['P', '件货']
])

// 委托状态
export const entrustStatus = new Map([
    ['NOACCEPT', '未受理'],
    ['ACCEPTED', '已受理'],
    ['VOID', '已作废'],
    ['OPERATING', '作业中'],
    ['FINISHED', '已完结'],
])
//预报状态
export const preStatus = new Map([
    ["NOACCEPT", "未确认"],
    //    ACCEPTED("ACCEPTED","已受理"),
    ["NOOPERATE", "未作业"],
    ["OPERATING", "作业中"],
    ["OPERATED", "已作业"],
    ["VOIDED", "已作废"],
    ["RETURNED", "已退回"],
    //    REVOKED("REVOKED","已撤回"),
    ["EXPIRED", "已过期"],
    //PENDING("PENDING","待复核"),
    ["FINISHED", "已完结"]
])

export const preStatus2 = new Map([
    ["NOACCEPT", "未确认"],
    ["NOOPERATE", "未作业"],
    ["OPERATING", "作业中"],
    ["FINISHED", "已完结"]
])

// 作业状态
export const jobStatus = new Map([
    ['NOOPERATE', '未作业'],
    ['RELEASE', '已发布'],
    ['VOIDED', '已作废'],
    ['OPERATING', '作业中'],
    ['OPERATED', '已作业'],
    ['CANCELLED', '已取消'],
])

// 过滤器
export const jobStatusFilter = new Map([
    ['NOOPERATE', '未作业'],
    ['RELEASE', '已发布'],
    ['VOIDED', '已作废'],
    ['OPERATING', '作业中'],
    ['OPERATED', '已作业'],
    ['CANCELLED', '已取消'],
    ['RETURNED', '已返场'],
    ['MOVED', '已移箱'],
])

// 是否空重
export const ifHeavyType = new Map([
    ['E', '空'],
    ['F', '重'],
])

// 内外贸
export const tradeType = new Map([
    ['I', '内贸'],
    ['O', '外贸'],
])

// 是否有效
export const validType = new Map([
    [true, '有效'],
    [false, '无效'],
])

// 运输方式
export const transportModeType = new Map([
    ['TR', '火车'],
    ['CR', '汽车'],
    ['SHIP', '船舶'],
])

// 出库方式
export const specify = new Map([
    [true, '指定箱'],
    [false, '大堆箱']
])

// 计划类型
export const planType = new Map([
    ['JCJH', '进场计划'],
    // ['CCJH', '出场计划'],
    ['CXJH', '拆箱计划'],
    ['ZXJH', '装箱计划'],
    ['NZRC', '内转入场计划'],
    ['NZCC', '内转出场计划'],
    ['ZCJH', '装车计划'],
    ['DDJH', '到达计划'],
    ['FYJH', '发运计划'],
    // ['XCJH', '卸车计划'],
    // ['ZSJH', '装船计划'],
    // ['XSJH', '卸船计划'],
    ['JGJH', '加工计划'],
    ['TXJH', '提箱计划'],
])

// 单位主体
export const orgStatusType = new Map([
    [true, '已启用'],
    [false, '已注销'],
])

export const accountType = new Map([
    ['M', '主账号'],
    ['S', '子账号'],
])

export const accountStatus = new Map([
    [true, '正常'],
    [false, '注销'],
])

export const sexType = new Map([
    ['MAN', '女'],
    ['WOMAN', '男'],
])

export const dicType = new Map([
    ['A', '数组'],
    ['D', '数据'],
])
// 计划作业状态
export const planStatus = new Map([
    ['NOOPERATE', '未作业'],
    ['OPERATING', '作业中'],
    ['COMPLETED', '已完成'],
    ['VOID', '已作废']
])
// 集装箱作业状态
export const containerJobType = new Map([
    ['IN_PORT', '进港'],
    ['OUT_PORT', '出港'],
    ['IN_TRANSFER', '内转入场'],
    ['OUT_TRANSFER', '内转出场'],
    ['IN_YARD', '进场'],
    ['OUT_YARD', '出场'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
])
// excel字段校验类型
export const excelFieldTypes = new Map([
    ['String', '字符串'],
    ['Int', '整数'],
    ['Float', '小数'],
    ['Enum', '枚举'],
    ['Date', '日期']
])

// 优先级
export const priorityType = new Map([
    ['1', '1'],
    ['2', '2'],
    ['3', '3'],
    ['4', '4'],
    ['5', '5'],
    ['6', '6'],
    ['7', '7'],
    ['8', '8'],
    ['9', '9'],
])
// 优先级 不可忽略
export const priorityTypes = new Map([
    [0, "不可忽略"],
    ["1", "1"],
    ["2", "2"],
    ["3", "3"],
    ["4", "4"],
    ["5", "5"],
    ["6", "6"],
    ["7", "7"],
    ["8", "8"],
    ["9", "9"]
]);
// 操作符
export const operatorType = new Map([
    ['EQ', '等于'],
    ['NE', '不等于'],
    ['CONTAIN', '包含'],
    ['NOTCONTAIN', '不包含'],
])
// 操作符-二期
export const operatorTwoType = new Map([
    ['EQ', '等于'],
    ['NE', '不等于'],
    ['CONTAIN', '包含'],
    ['NOTCONTAIN', '不包含'],
    ['ISNULL', '为空'],
    ['NOTNULL', '不为空'],
])
// 因素枚举
export const attrType = new Map([
    ['transportMode', '运输方式'],
    ['cargoName', '货名'],
    ['containerOwner', '箱主单位'],
    ['entrustFrom', '委托来源'],
    ['entrustOrgId', '委托单位'],
    ['containerType', '箱型'],
    ['stratStationCode', '发站'],
    ['ifHeavy', '空重'],
    ['importAndExport', '进出口'],
    ['containerSize', '尺寸'],
    ['tradeType', '内外贸'],
    ['containerNo', '箱号'],
])
// 是否在港
export const portStatusType = new Map([
    [true, '在港'],
    [false, '不在港'],
])
// 排序方向
export const sOrB = new Map([
    ['FSTB', '从小到大'],
    ['FBTS', '从大到小'],
])
// 堆放顺序
export const stackOrder = new Map([
    ['FTBR', '先层后排'],
    ['FRBT', '先排后层'],
])
// 进出口
export const importAndExportType = new Map([
    ['IM', '进口'],
    ['EX', '出口']
])
export const importAndExportTypeByIO = new Map([
    ['I', '进口'],
    ['O', '出口']
])

// 外理进出口
export const importExport = new Map([
    ['IM', '进口'],
    ['EX', '出口']
])
// 有无委托
export const entrustNoType = new Map([
    ['ISNULL', '无'],
    ['NOTNULL', '有']
])

// 箱状态
export const containerStatus = new Map([
    [true, '坏箱'],
    [false, '正常'],
])

// 指令状态
export const commandStatus = new Map([
    ["NOOPERATE", "未作业"],
    ["OPERATE", "作业中"],
    ["COMPLETED", "已完成"],
    ["VOID", "已作废"],
    ["EXPIRED", "已过期"],
])

// 作业目的
export const jobPurpose = new Map([
    ['TX', '提箱'],
    ['JC', '进场'],
    ['NZCC', '内转出场'],
    ['NZRC', '内转入场'],
    ['DCZL', '堆场整理'],
    ['CXYX', '拆箱移箱'],
    ['CXFC', '拆箱返场'],
])

// 登记类型
export const registerType = new Map([
    ['THCC', '提货出场'],
    ['JCRC', '进场入库'],
])

// 动作
export const jobAction = new Map([
    ['XCLD', '卸车落地'],
    ['XCSJ', '卸车上架'],
    ['ZT', '装车'],
    ['SJ', '上架'],
    ['XJLD', '下架落地'],
    ['XJZT', '下架装车'],
    ['FX', '翻箱'],
    ['YX', '移箱'],
])

// 堆场策划类型
export const yardPlanType = new Map([
    ['JKZX', '进口重箱策划'],
    ['JKKX', '进口空箱策划'],
    ['CKZX', '出口重箱策划'],
    ['CKKX', '出口空箱策划'],
    ['DDTX', '大堆提箱策划'],
])

// 船舶类型
export const shipType = new Map([
    ['CONTAINER', '集装箱船'],
    ['CARGO', '件散货船'],
])

// 外理-作业状态
export const shipPlanStatus = new Map([
    ['ONE', '未作业'],
    ['TWO', '作业中'],
    ['THREE', '退回作业'],
    ['FOUR', '理箱完成'],
    ['FIVE', '外理封航'],
    ['SIX', '拆提封航'],
])
//调整方式
export const accountChangeWay = new Map([
    ['ADD', '增补'],
    ['REDUCE', '扣减']
])

// 是否完成
export const isFinish = new Map([
    [true, '已完成'],
    [false, '未完成'],
])
// 作业状态
export const operationState = new Map([
    ['ONE', '未作业'],
    ['TWO', '作业中'],
    ['THREE', '已完成'],
    ['FOUR', '已审核'],
])

// 特殊箱作业类型
export const tsJobStatus = new Map([
    ['XZ', '熏蒸'],
    ['EZ', '二转'],
    // ['ZX','装箱'],
    // ['CX','拆箱'],
    ['OTHER', '其它'],
])

// 特殊箱作业类型
export const tsJobStatusNew = new Map([
    ['XZ', '熏蒸'],
    ['EZ', '二转'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
    ['OTHER', '其它'],
    ['CHANGE', '调账'],
])
// 所有作业类型
export const allJobStatus = new Map([
    ['XZ', '熏蒸'],
    ['EZ', '二转'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
    ['ZC', '装船'],
    ['XC', '卸船'],
    ['OTHER', '其它'],
])
// 所有作业类型
export const allJobStatusNew = new Map([
    ['ZC', '装船'],
    ['XC', '卸船'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
    ['XZ', '熏蒸'],
    ['EZ', '二转'],
    ['T', '提箱放行'],
    ['C', '拆箱放行']
])
// 特殊箱作业类型
export const tallyPlanStatus = new Map([
    ['ONE', '未作业'],
    ['TWO', '作业中'],
    ['THREE', '已完成'],
    ['FOUR', '已核对'],
])

// 港口枚举
export const portCode = new Map([
    ["GYG", "果园港"],
    ["CTG", "寸滩港"],
    ["JLG", "玖龙港"],
    ["LWG", "理文港"],
    ["WZG", "万州港"],
    ["CSG", "长寿港"],
    ["FLG", "涪陵港"],
    ["XG", "新港"],
    ["LHG", "珞璜港"],
    ["WZXTG", "万州新田港"]
])

// 船计划类型
export const shipPlanType = new Map([
    ['ZC', '装船'],
    ['XC', '卸船'],
])

// 船计划类型
export const enchaseWayType = new Map([
    ['GZ', '港装'],
    ['CZ', '厂装'],
])

// 是否中转
export const isChange = new Map([
    ['1', '是'],
    ['0', '否'],
])

// 残损代码
export const dageType = new Map([
    ["B", "破损"],
    ["DE", "变形"],
    ["M", "灭失"],
    ["H", "洞"],
    ["D", "凹损"],
    ["BL", "凸损"],
    ["C", "刮伤"],
    ["", "其他"],
])

// 放行类型
export const releaseType = new Map([
    ['T', '提箱放行'],
    ['C', '拆箱放行'],
])

// 结算方式
export const settlementType = new Map([
    ['M', '月结'],
    ['C', '现结'],
])
// 是否残损
export const isDamagedType = new Map([
    ['0', '否'],
    ['1', '是'],
])

// 规则-业务模式
export const businessModule = new Map([
    ['JZX', '集装箱'],
    ['JH', '件货'],
    ['SH', '散货'],
    ['WL', '外理'],
])
// 规则-计费指标
export const feeUnit = new Map([
    ["A", "月累计量"],
    ["B", "月累计TEU"],
    ["C", "箱次"],
    ["D", "TEU"],
    ["E", "吨"],
    ["F", "车皮"],
])
// 规则-操作符
export const ruleOperator = new Map([
    ['equal', '等于'],
    ['nEqual', '不等于'],
    ['gEqual', '大于等于'],
    ['lEqual', '小于等于'],
    ['gThan', '大于'],
    ['lThan', '小于'],
    ['like', 'LIKE'],
    ['nLike', 'NOTLIKE'],
    ['in', 'IN'],
    ['nIn', 'NOTIN'],
])
// 操作符2
export const ruleOperatorType = new Map([
    ['equal', '等于'],
    ['nEqual', '不等于'],
    ['in', '包含'],
    ['nIn', '不包含'],
    ['gEqual', '大于等于'],
    ['lEqual', '小于等于'],
    ['gThan', '大于'],
    ['lThan', '小于'],
])
// 规则-连接符
export const ruleConnect = new Map([
    ['AND', 'AND'],
    ['OR', 'OR'],
])
// 残损代码
export const damaged = new Map([
    ["B", "破损"],
    ["DE", "变形"],
    ["M", "灭失"],
    ["H", "洞"],
    ["D", "凹损"],
    ["BL", "凸损"],
    ["C", "刮伤"],
    ["OTHER", "其他"],
])

//日报月报

export const planReport = new Map([
    ["Total", "合计"],
    ["CX", "拆箱理货量"],
    ["Pass", "提箱放行量"],
    ["ZX", "装箱理货量"],
])

// 所属仓库
export const warehouse = new Map([
    ['A01', '果园库'],
    ['A02', '港华库'],
])

// 仓库类型
export const areaType = new Map([
    ['XN', '虚拟仓库'],
    ['JG', '监管仓库'],
])

// 原则
export const principle = new Map([
    ['HZ', '货主'],
    ['PM', '品名'],
    ['GL', '管理方式'],
    ['JL', '计量方式'],
    ['RK', '入库方式'],
    ['G1', '规格1'],
    ['G2', '规格2'],
    ['G3', '规格3'],
    ['CZ', '材质'],
    ['SCCJ', '生产厂家']
])

// 优先级
export const priority = new Map([
    ['0', '不可忽略'],
    ['1', '1'],
    ['2', '2'],
    ['3', '3'],
    ['4', '4'],
    ['5', '5'],
    ['6', '6'],
    ['7', '7'],
    ['8', '8'],
    ['9', '9']
])

// 管理方式
export const management = new Map([
    ['UNIFIED', '统一管理'],
    ['SPECIFY', '指定管理']
])

// 入库方式
export const putStyle = new Map([
    ['SY', '水运入库'],
    ['CP', '车皮入库'],
    ['QC', '汽车入库'],
    ['TZ', '调账入库'],
    ['TH', '退货入库'],
])


// 限制因素
export const limitFactor = new Map([
    ['W', '重量'],
    ['N', '件数'],
])

// 日历类型
export const calendarType = new Map([
    ['SOLAR', '阳历'],
    ['LUNAR', '阴历'],
])

// 业务模式
export const businessMode = new Map([
    ['JH', '件货业务'],
    ['SH', '散货业务'],
    ['JZX', '集装箱业务'],
    ['WL', '外理业务'],
])


// 规则条件
export const ruleCondition = new Map([
    ['RK', '入库方式'],
    ['YS', '运输方式'],
    ['CK', '出库方式'],
])

// 规则条件2
export const ruleCondition2 = new Map([
    ['SY', '水运入库'],
    ['TH', '提货入库'],
    ['HC', '火车入库'],
    ['QC', '汽车入库'],
])

// 卡类型
export const cardType = new Map([
    ['C', '车卡'],
    ['MS', '月结卡'],
    ['P', '员工卡'],
])

// 使用状态
export const useStatus = new Map([
    ['ENABLED', '可用'],
    ['USED', '已用'],
    ['DISABLED', '不可用'],
])

// 品名
export const productName = new Map([
    ['GX', '高线'],
    ['LWG', '螺纹钢'],
    ['XC', '线材'],
    ['BC', '板材'],
])


// 计量方式
export const meterStyle = new Map([
    ['ID', '标识'],
    ['RULER', '检尺'],
    ['WEIGHT', '检斤'],
])


// 账户类型
export const accountTypes = new Map([
    ['CREDIT', '信誉账户'],
    ['NORMAL', '普通账户'],
    ['MONTHLY', '月结账户'],
    // ['QF','欠费客户'],
])

// 账户性质
export const accountNature = new Map([
    ['CONTRACTED', '合同客户'],
    ['OPENED', '开户客户'],
    ['SEMTTLEMENT', '结算客户']
])

// 新增账户
export const newAccountNature = new Map([
    // ['CONTRACTED', '合同客户'],
    ['OPENED', '开户客户'],
    ['SEMTTLEMENT', '结算客户']
])

// 逾期类型
export const overdueType = new Map([
    ['AMOUNT', '欠费金额'],
    ['DAYS', '逾期天数'],
    ['WU', '无']
])

// // 车辆类别
// export const categoryName = new Map([
//     ['ZY','自有'],
//     ['GK','挂靠'],
// ])

// 库房类型
export const roomType = new Map([
    ['IN', '室内库房'],
    ['OUT', '室外库房'],
])

// 库房类型
export const workMode = new Map([
    ['JZX', '集装箱作业'],
    ['JH', '外理作业'],
    ['SH', '全程物流'],
    ['WL', '件货作业'],
])

//作业类型
export const taskType = new Map([
    ["ONE", "装船"],
    ["TWO", "卸船"],
    ["THREE", "装箱"],
    ["FOUR", "拆箱"],
    ["FIVE", "熏蒸"],
    ["SIX", "二转"],
    ["SEVEN", "提箱放行"],
    ["EIGHT", "拆箱放行"],

])

//入库结算
export const inSettleStyle = new Map([
    ["UNIFIED", "统一结算"],
    ["DETAIL", "明细结算"],
])

//出库结算
export const outSettleStyle = new Map([
    ["A", "换算重量"],
    ["B", "实发重量"],
    ["C", "实发整收"],
])

// 控制状态
export const controlStatus = new Map([
    ["A", '有效'],
    ["B", '无效'],
])
//控制方式
export const controlWay = new Map([
    ["A", "所有账页(含新增)"],
    // ["P","部分账页(全选也不算新增)"],
])

//控制类型
export const controlType = new Map([
    ["FH", "放货"],
    ["ZY", "质押"],
])

//审核状态 
export const auditStatus = new Map([
    // ["A","草稿"],
    ["B", "待审核"],
    ["C", "已审核"],
    ["D", "已退回"],
])

//账页类型 
export const accountPageType = new Map([
    ["A", "原料账页"],
    ["B", "成品账页"]
])


//账页类型 
export const adjustWay = new Map([
    ["TZRK", "调整入库"],
    ["TZCK", "调整出库"]
])

//调账复核状态 
export const adjustStatus = new Map([
    ["A", "草稿"],
    ["B", "待审核"],
    ["C", "已审核"],
    ["D", "已退回"],
])

//入库复核状态 
export const inwayStatus = new Map([
    ["A", "未验收"],
    ["B", "未复核"],
    ["C", "已复核"],
    ["D", "已退回"],
])

//
export const adjustStatus1 = new Map([
    ["TZRK", "调账入库"],
    ["TZCK", "调账出库"],
    ["KWXZ", "库位修正"],
])

//
export const handleStatus = new Map([
    ["A", "未处理"],
    ["B", "已处理"],
])

//
export const inOutType = new Map([
    ["IN", "入库"],
    ["OUT", "出库"],
])

//
export const stockStatus = new Map([
    ["RECEIVED", "已验收"],
    ["STOCKED", "未上账"],
    ["ACCOUNTED", "已上账"],
    ["OUTED", "已出库"],
    ["OPENED", "已开单"],
    // ["CHANGED", "已换票"],
])


//移位类型
export const relocationType = new Map([
    ["A", "仓库间"],
    ["B", "库房间"],
    ["C", "库房内"],
])

//数量单位
export const countNumUnitEnum = new Map([
    ["C", "张"],
    ["A", "支"],
    ["B", "根"],
])

//移位单状态
export const shiftStatus = new Map([
    ["NOOPERATE", "未作业"],
    ["OPERATING", "作业中"],
    ["OPERATED", "已作业"],
    // ["VOIDED","已作废"],
    // ["EXPIRED","已过期"],
])

//盘点状态
export const checkStatus = new Map([
    ["NOOPERATE", "未作业"],
    ["OPERATING", "作业中"],
    ["OPERATED", "已作业"],
    ["CANCELLED", "已取消"],
    ["RELEASED", "已发布"],
    ["VOIDED", "已作废"],
    ["EXPIRED", "已过期"],
])

//提单来源 _filterPresource
export const presource = new Map([
    ["ONLINE", "网上受理"],
    ["MANUAL", "人工录入"],
    ["MANUAL_QQ", "人工-QQ"],
    ["MANUAL_FAX", "人工-传真"],
    ["ONLINE_DZ", "网受-大宗"],
    ["ONLINE_GD", "网受-高达"],
])
//提单来源(新增和编辑) _filterPresource
export const addPresource = new Map([
    ["MANUAL", "人工录入"],
    ["MANUAL_QQ", "人工-QQ"],
    ["MANUAL_FAX", "人工-传真"]
])
//出库方式
export const outWay = new Map([
    ["THCK", "提货出库"],
    ["HZCK", "划转出库"],
    ["BDCK", "罢单出库"],
    ["DJCK", "对接出库"],
    ["JGCK", "加工出库"],
    ["ZXCK", "专线出库"],
    ["TZCK", "调账出库"],
    ["YKCK", "盈亏出库"],
    ["CPCK", "成品出库"]
])
//现提幅度
export const limitRange = new Map([
    ["A", "上限"],
    ["B", "下限"],
    ["C", "清库"],
    ["D", "无"]
])
//提单类型
export const stockType = new Map([
    [true, "临时提单"],
    [false, "原件"]
])
//提单状态
export const billStatus = new Map([
    ['NOACCEPT', "未受理"],
    ['NOOPERATE', "未作业"],
    ['OPERATING', "作业中"],
    ['VOIDED', "已作废"],
    ['RETURNED', "已退回"],
    ['EXPIRED', "已过期"],
    ['FINISHED', "已完结"]
])
//提单审核状态
export const billAuditStatus = new Map([
    ['A', "草稿"],
    ['B', "待审核"],
    ['C', "已审核"],
    ['D', "已退回"],
])
//出库单状态
export const OutBillStatus = new Map([
    ['CANCELLED', "已取消"],
    ['NOOPERATE', "未作业"],
    ['OPERATING', "作业中"],
    ['OPERATED', "已作业"],
    ['RELEASED', "已发布"],
    ['VOIDED', "已作废"],
    ['EXPIRED', "已过期"]
])

//业务类型 
export const businessType = new Map([
    ["ZXRK", "专线入库"],
    ["SYRK", "水运入库"],
    ["CPRK", "成品入库"],
    ["THCK", "提货出库"],
    ["JGCK", "加工出库"],
    ["CPCK", "成品出库"],
    ["DJCK", "对接出库"],
    ["YKZY", "移库转运"],
])

//上账状态
export const bookStatus = new Map([
    ["A", "草稿"],
    ["B", "待上账"],
    ["C", "已上账"],
])
//进闸目的
export const gateStatus = new Map([
    ["ZXRK", "专线入库"],
    ["SYRK", "水运入库"],
    ["QCRK", "汽车入库"],
    ["ZXDJ", "专线对交"],
    ["SYDJ", "水运对交"],
    ["CPRK", "成品入库"],
    ["THRK", "退货入库"],
    ["YKRK", "盈亏入库"],
    ["HZRK", "划转入库"],
    ["TZRK", "调账入库"]
])
//来料方式
export const cargoFromStatus = new Map([
    ["LL", "来料"],
    ["KN", "库内"]
])
//加工方式
export const machiningModeStatus = new Map([
    ["DBJG", "打包加工"],
    ["DXJG", "镀锌加工"],
    ["FBJG", "翻包加工"],
    ["GCJG", "管材加工"],
    ["LZDXJG", "冷轧镀锌加工"],
    ["LZJG", "冷轧加工"],
    ["PLJZ", "盘螺校直"],
    ["RZJG", "热轧加工"],
    ["RZSXJG", "热轧酸洗加工"],
    ["SXJG", "酸洗加工"]
])
//包装方式
export const packageMode = new Map([
    ["FXBZ", "防锈包装"],
    ["GZBZ", "钢带夹木方(自带)包装"],
    ["GMBZ", "钢带夹木方包装"],
    ["JDBZ", "简包装"],
    ["MFBZ", "木方包装"]
])


//出入库方式
export const inOutWay = new Map([
    ["ZXRK", "专线入库"],
    ["SYRK", "水运入库"],
    ["QCRK", "汽车入库"],
    ["ZXDJ", "专线对交"],
    ["SYDJ", "水运对交"],
    ["CPRK", "成品入库"],
    ["THRK", "退货入库"],
    ["YKRK", "盈亏入库"],
    ["HZRK", "划转入库"],
    ["TZRK", "调账入库"],
    ["THCK", "提货出库"],
    ["HZCK", "划转出库"],
    ["BDCK", "罢单出库"],
    ["DJCK", "对接出库"],
    ["JGCK", "加工出库"],
    ["TZCK", "调账出库"],
    ["YKCK", "盈亏出库"],
    ["CPCK", "成品出库"],
    ["YKHZ", "原库划转"]
])
//出库方式
export const sendOutWay = new Map([
    ["THCK", "提货出库"],
    ["HZCK", "划转出库"],
    ["BDCK", "罢单出库"],
    ["DJCK", "对接出库"],
    ["JGCK", "加工出库"],
    ["YKCK", "盈亏出库"],
    ["CPCK", "成品出库"],
    ["YKHZ", "原库划转"]
])
//原材料提单出库方式
export const oriOutWay = new Map([
    ["THCK", "提货出库"],
    ["JGCK", "加工出库"],
    ["YKHZ", "原库划转"],
])
//成品出库方式
export const hasOutWay = new Map([
    ["CPCK", "成品出库"],
    ["JGCK", "加工出库"],
])
//对接出库方式
export const duiOutWay = new Map([
    ["DJCK", "对接出库"]
])
//单据类型
export const orderStatus = new Map([
    ["TDSL", "提单受理"],
    ["JGJS", "加工结算"],
    ["JGSL", "加工受理"],
    ["CKJS", "出库结算"],
    ["DDYB", "到达预报"],
    ["ZKSL", "转库受理"],
    ["YJHX", "月结核销"],
    ["CDSZ", "存单上账"]
])

//计件类型
export const piecesType = new Map([
    ["YANS", "验收单"],
    ["CHUK", "出库单"],
    ["YUNS", "运输单"],
    ["YWJHD", "移位计划单"]
])
//单据类型
export const newPiecesType = new Map([
    ["YANSD", "验收单"],
    ["CHUKD", "出库单"],
    ["YUNSD", "运输单"],
    ["YWJHD", "移位计划单"]
])
//收款方式
export const payWay = new Map([
    ["WECHAT", "微信"],
    ["BANK", "银行"],
    ["CASH", "现金"]
])
//费用类型
export const chargeType = new Map([
    ["YSF", "预收费"],
    ["RKF", "入库费"],
    ["BGF", "保管费"],
    ["DJF", "对接费"],
    ["JGF", "加工费"],
    ["ZZF", "转账费"],
    ["CKF", "出库费"]
])
//入库费用结算方式
export const inSettlementMode = new Map([
    ["UNIFIED", "统一结算"],
    ["DETAIL", "明细结算"]
])
//预付款状态
export const prePaymentStatus = new Map([
    ["A", "草稿"],
    ["B", "待交款"],
    ["C", "已交款"],
])
//结算方式
export const settleWay = new Map([
    ["XJ", "现结"],
    ["CD", "冲抵"],
    ["XJCD", "现结/冲抵"],
    ["YJ", "月结"]
])
//新结算方式
export const newSettleWay = new Map([
    ["XJ", "现结"],
    ["CD", "冲抵"],
    ["XJCD", "现结/冲抵"],
    ["YJGZ", "月结挂账"],
    ["YJFZ", "月结付账"],
    ["YJCD", "月结冲抵"],
    ["YJBSF", "月结不收费"]
])
//核销方式

export const writeOfWay = new Map([
    ["FZHX", "付账核销"],
    ["CDHX", "冲抵核销"],
    ["BSFHX", "不收费核销"]
])
//核销方式

export const recordType = new Map([
    ["ADVANCE", "预收"],
    ["DEDUCT", "扣款"],
    ["REFUND", "退款"]
])
//授权类型,可用值:DC,LW

export const authorizeType = new Map([
    ["DC", "单次"],
    ["LW", "量完"]
])

export const powerType = new Map([
    ["BC", "磅差"],
    ["SX", "上限授权"],
    ["CG", "冲关"]
])

export const proofreadBill = new Map([
    ["0", "未改动"],
    ["1", "未上传"],
    ["2", "已上传"]
])

export const luShip = new Map([
    ["Z", "装船"],
    ["X", "卸船"]
])

export const luTrain = new Map([
    ["Z", "装车"],
    ["X", "卸车"]
])

// 货类（生产日报使用）
export const cargoType4DailyReport = new Map([
    ['00001','煤炭及制品'],
    ['00002','石油、天然气及制品'],
    ['00003','金属矿石'],
    ['00004','钢铁'],
    ['00005','矿建材料'],
    ['00006','水泥'],
    ['00007','木材'],
    ['00008','非金属矿石'],
    ['00009','化肥及农药'],
    ['00010','盐'],
    ['00011','粮食'],
    ['00012','机械、设备、电器'],
    ['00013','化工原料及制品'],
    ['00014','有色金属'],
    ['00015','轻工、医药产品'],
    ['00016','农、林、牧、渔业产品'],
    ['00017','其它']
])

export const ZYZT = new Map([
    ["NOTWORK", "待装车"],
    ["WORKING", "作业中"],
    ["COMPLETED", "作业完成"],
    ["LOADED", "已装车"],
    ["SENDED", "已发车"],
    ["UNLOADED", "已卸车"],
])

export const TLJHLY = new Map([
    ["INTERFACE", "接口导入"],
    ["EDI", "EDI导入"],
    ["EXCEL", "EXCEL导入"],
])

export const ZYLX = new Map([
    ["DBZY", "短驳转运"],
    ["DBZYI", "短驳转运（进口）"],
    ["DBZYO", "短驳转运（出口）"],
    ["TTZZ", "铁铁中转"],
    ["ZYXC", "专运线卸车"],
    ["HHZY", "混合作业"],
])

export const JCK = new Map([
    ["IM", "进口"],
    ["EX", "出口"],
    ["CG", "中转"],
])

export const FCSHZT = new Map([
    ["UNAUDIT", "未审核"],
    ["AUDITED", "已审核"],
])


// WEBPACK FOOTER //
// ./src/assets/dict.js